import HorizontalMenu from "../components/horizontalMenu";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import './templates.css'
import { useParams } from "react-router";
import getTodayDate from '../utils/currentDate';
import ChallengeLogoSelection from "../components/ChallengeLogoSelection";
//
const Template = () => {

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        privacyLevel: 'Private',
        tasks: Array(21).fill(''), 
      });
    
    const [username, setUsername] = useState('');
    const [logoSelection, setLogoSelection] = useState('TrophyA');
    
    const navigate = useNavigate();

      const { template_id } = useParams();

      const handleLogoSelection = (value) => {
        setLogoSelection(value);
      }
    
      const handleChange = (e, index = null) => {
        const { name, value } = e.target;
        if (name === 'title' || name === 'description' || name === 'privacyLevel' || name === 'startDate') {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
          }));
        } else if (name.startsWith('task')) {
          const taskIndex = parseInt(name.split('-')[1], 10);
          const updatedTasks = [...formData.tasks];
          updatedTasks[taskIndex] = value;
          setFormData((prevFormData) => ({
            ...prevFormData,
            tasks: updatedTasks
          }));
        }
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form data submitted:', formData);
        // Handle form submission (e.g., send data to server)
        formData['username'] = username;
        formData['icon'] = logoSelection;
        formData['rules'] = 'No rules!'; // Existing for if the decision is ever made to add a rules field

        axiosInstance.post('/challenges/create', formData)
        .then(response => { navigate('/home')})
        .catch(error => {})
      };


      useEffect(() => {
        axiosInstance.get('/users/user').then(response => setUsername(response.data.username))
        .catch(error => {});
        axiosInstance.get(`/templates/${template_id}`)
        .then(response => setFormData(response.data))
        .then(() => {
            setFormData((prevFormData) => ({...prevFormData, privacyLevel: "Private", startDate: getTodayDate()}))
        })
        .catch(error => {})
      },[]);

    return (
        <div>
        <HorizontalMenu />  
        <div className="form-container-template">
      <h1 className="template-h1">Create a new challenge</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <label>Start Date</label>
        <div className="form-group">
            <input className="startDateTemplate" name="startDate" onChange={handleChange} defaultValue={getTodayDate()} type="date" min={getTodayDate()}></input>
        </div>
        <label>Visibility</label>
        <div className="form-group">
            <select className="visibilityOptions" name="privacyLevel" value={formData.privacyLevel} onChange={handleChange}>
                <option value="Private">Private</option>
                <option value="Public">Public</option>
            </select>
        </div>

        <label>Icon</label>
       <ChallengeLogoSelection updateLogoSelection={handleLogoSelection}/>

        <div className="form-group">
          <label>Tasks</label>
          {formData.tasks.map((task, index) => (
            <input
              key={index}
              type="text"
              name={`task-${index}`}
              value={task}
              onChange={(e) => handleChange(e, index)}
              placeholder={`Day ${index + 1}`}
            />
          ))}
        </div>
        <button className="template-button" type="submit">Create Challenge</button>
      </form>
    </div>
        </div>
    
    )

}

export default Template;